import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import ChartImage3 from '../../../../assets/img/aboutmogul1.png'
import ChartImage4 from '../../../../assets/img/logo_purple_arialblack120.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';
import HomeSlogan from "../../../home_1column/style/slogan";
import HomeSlogan2 from "../../../../components/heading/slogan2";
import HomeSubtitle from "../../../home_1column/style/subtitle";

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '70px', paddingBottom: '0px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 12}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        minHeight: 'auto',
                                        position: 'relative',
                                        padding: '10%',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>  
                                     
                                    <HomeSubtitle>
                                        <img src={ChartImage4} alt="MOGUL"/>  
                                    </HomeSubtitle>  

                                    <HomeSlogan2>
                                        Property Management Made Easy Using AI
                                    </HomeSlogan2>
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 12}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        minHeight: 'auto',
                                        position: 'relative',
                                        padding: '0%',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>      
                                    <img src={ChartImage3} alt="MOGUL"/>
                                </div>
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
